<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.hdpou")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-2.col-xl-2.mb-1
                b-input-group(:prepend='$t("ui.type")' size="sm")
                  label.type-switch.type-switch-label.type-switch-success.mb-0
                    input(type="checkbox" class="type-switch-input" v-model="full_amount" :disabled="loading")
                    span(class="type-switch-slider" :data-checked="$t('ui.full')" :data-unchecked="$helpers.getLabelName(accountType)")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="timer + ' ' + $t('ui.seconds')" isModal=false type="button" @click="search")
            b-row
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                .table-sm.table-responsive
                  table#tblList.table.table-hover.table-bordered
                    thead
                      tr
                        th.align-middle.text-center.bg-grey-lighter(colspan=2) &nbsp;
                        th.align-middle.text-center.bg-grey-transparent-1(colspan=2) {{ $t("ui.full_time") }}
                        th.align-middle.text-center.bg-grey-transparent-3(colspan=2) {{ $t("ui.first_half") }}
                      tr
                        //- th.align-middle.text-center.bg-grey-lighter(style="width:4%;") #
                        th.align-middle.text-left.bg-grey-lighter(style="width:10%;") {{ $t("ui.date_time") }}
                        th.align-middle.text-center.bg-grey-lighter(style="width:30%;") {{ $t("ui.event") }}
                        th.align-middle.text-center.bg-grey-transparent-1(style="width:14%;") {{ $t("ui.hdp") }}
                        th.align-middle.text-center.bg-grey-transparent-1(style="width:14%;") {{ $t("ui.ou") }}
                        th.align-middle.text-center.bg-grey-transparent-3(style="width:14%;") {{ $t("ui.hdp") }}
                        th.align-middle.text-center.bg-grey-transparent-3(style="width:14%;") {{ $t("ui.ou") }}
                    tbody
                      template(v-if="filterLeague()")
                        template(v-for="(league,index) in filterLeague()" :keys="index")
                          tr
                            td.bg-grey-transparent-2(colspan=7) #[b {{ getName(league, 0) }}]
                          template(v-for="(match,index) in filterMatch(1, league)" :keys="index")
                            tr.live
                              //- td.align-middle.text-center {{ match }}
                              td.align-middle.text-left
                                span.mr-1.badge.badge-green.blink_me {{ $t("ui.live") }}
                                span {{ match.split(",")[1] + " - " + match.split(",")[2] }}
                              td.align-middle.text-center {{ getMatchTeam(match.split(",")[0]) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(1, match, "HDP"))' @click='redirectTo(1, match, "HDP")') #[b {{ getBetTypeStock(1, match, "HDP") }}]
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(1, match, "OU"))' @click='redirectTo(1, match, "OU")') #[b {{ getBetTypeStock(1, match, "OU") }}]
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(1, match, "HDPH"))' @click='redirectTo(1, match, "HDPH")') #[b {{ getBetTypeStock(1, match, "HDPH") }}]
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(1, match, "OUH"))' @click='redirectTo(1, match, "OUH")') #[b {{ getBetTypeStock(1, match, "OUH") }}]
                          template(v-for="match in filterMatch(0, league)")
                            tr
                              //- td.align-middle.text-center {{ match }}
                              td.align-middle.text-left {{ $moment(match.split(",")[3]).format("YYYY-MM-DD HH:mm:ss") }}
                              td.align-middle.text-center {{ getMatchTeam(match.split(",")[0]) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(0, match, "HDP"))' @click='redirectTo(0, match, "HDP")') #[b {{ getBetTypeStock(0, match, "HDP") }}]
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(0, match, "OU"))' @click='redirectTo(0, match, "OU")') #[b {{ getBetTypeStock(0, match, "OU") }}]
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(0, match, "HDPH"))' @click='redirectTo(0, match, "HDPH")') #[b {{ getBetTypeStock(0, match, "HDPH") }}]
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(0, match, "OUH"))' @click='redirectTo(0, match, "OUH")') #[b {{ getBetTypeStock(0, match, "OUH") }}]
                      template(v-else)
                        tr(style="background-color:#f2f4f5")
                          td.align-middle.text-center(colspan=7)
                            div.my-2 {{ $t("message.no_records") }}
</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton.vue"

export default {
  components: {
    SubmitButton
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      betList: [],
      matchList: [],
      full_amount: true,
      pulling: null,
      countdown: null,
      timer: 60,
      betListDetail: {
        full_amount: true,
        bet_type: "",
        match_id: 0,
        is_live: 0,
        home_running_score: 0,
        away_running_score: 0
      },
      match: [],
      league: []
    };
  },
  validations: {},
  computed: {
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    },
    accountType() {
      return this.$store.getters.accountType
    }
  },
  mounted: function() {
    this.search()
    this.countdown = setInterval(() => {
      this.timer -= 1
    }, 1 * 1000)
    this.pulling = setInterval(() => {
      this.search()
      this.timer = 60
    }, 1 * 61000)
  },
  beforeDestroy: function() {
    clearInterval(this.pulling)
    clearInterval(this.countdown)
  },
  methods: {
    redirectTo: function(is_live, match, bet_type) {
      this.betListDetail.full_amount = (this.full_amount) ? 1 : 0
      this.betListDetail.bet_type = bet_type
      this.betListDetail.match_id = parseInt(match.split(",")[0])
      this.betListDetail.is_live = is_live
      this.betListDetail.home_running_score = parseInt(match.split(",")[1])
      this.betListDetail.away_running_score = parseInt(match.split(",")[2])
      this.$store.dispatch("layout/setBetListDetail", this.betListDetail)
      this.$router.push("/betListHDPOUDetails")
    },
    filterLeague: function() {
      if(this.betList.length > 0) {
        return this.betList.map(item => item.league_id).filter((value, index, self) => self.indexOf(value) === index)
      }
    },
    filterMatch: function(is_live, league) {
      let result = []
      let allMatch = this.betList.filter((value, index, self) => value.league_id == league)
      if(this.betList.length > 0) {
        let match = []
        if(is_live == 1) {
          let live = allMatch.filter((value, index, self) => value.is_live == 1)
          result = live.map(item => (item.match_id+","+item.home_running_score+","+item.away_running_score)).filter((value, index, self) => self.indexOf(value) === index)
        } else {
          let nonlive = allMatch.filter((value, index, self) => value.is_live == 0)
          result = nonlive.map(item => (item.match_id+","+item.home_running_score+","+item.away_running_score+","+item.match_time)).filter((value, index, self) => self.indexOf(value) === index)
        }
      }
      return result
    },
    getMatchTime: function(match) {
      if(this.betList.length > 0) {
        let matchLeague = this.betList.filter((value, index, self) => value.match_id == match)
        return this.$moment(matchLeague[0].match_time).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    getMatchTeam: function(match) {
      if(this.betList.length > 0) {
        return this.getName(match, 1) + " vs " + this.getName(match, 2)
      }
    },
    getBetTypeStock: function(is_live, match, bet_type) {
      if(this.betList.length > 0) {
        let result = []
        let isHome = 0
        let isAway = 0
        let id = match.split(",")[0]
        let homeScore = match.split(",")[1]
        let awayScore = match.split(",")[2]
        result = this.betList.filter((value, index, self) => value.match_id == id && value.bet_type == bet_type && value.is_live == is_live && value.home_running_score == homeScore && value.away_running_score == awayScore)
        for(let i in result) {
          if (result[i].home_away == 1) {
            isHome = (this.full_amount) ? Math.ceil(result[i].bet_member) : Math.ceil(result[i].bet_agent)
          } else {
            isAway = (this.full_amount) ? Math.ceil(result[i].bet_member) : Math.ceil(result[i].bet_agent)
          }
        }
        return isHome - isAway
      }
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    search: function() {
      if (!this.$v.$invalid) {
        let url = config.getStockHDPUrl()
        this.loading = true
        this.$store
          .dispatch("user/getStock", { url })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.betList = response.data
                this.betList = this.betList.sort(function(a,b){
                  return new Date(a.match_time) - new Date(b.match_time)
                })
                this.match = response.names.match
                this.league = response.names.league
              } else {
                this.betList = []
                this.match = []
                this.league = []
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.betList = []
            this.match = []
            this.league = []
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    }
  }
};
</script>